import { List, Map } from 'immutable'

export const selectOnboarding = (state) => state.onboarding || Map()

export const selectOnboardingTopics = (state) => selectOnboarding(state).getIn(['v5Data', 'rank-interests'], Map())

export const selectOnboardingGenericTerms = (state) => selectOnboarding(state).getIn(['v5Data', 'skip'], List())
